import { useState, useRef, useEffect } from 'react';
import './BillTraceModal.css';

const BillTraceModal = ({ outletData }) => {
    const [showModal, setShowModal] = useState(false);
    const startCoords = useRef({ x: 0, y: 0 });
    const isMobile = useRef(false);
    const threshold = 100; // Swipe distance threshold
  
    useEffect(() => {
      isMobile.current = window.innerWidth <= 768; // Mobile screen width
    }, []);
  
    const handleTouchStart = (e) => {
      if (!isMobile.current) return;
      const touch = e.touches[0];
      startCoords.current = { x: touch.clientX, y: touch.clientY };
    };
  
    const handleTouchMove = (e) => {
      if (!isMobile.current) return;
  
      const touch = e.touches[0];
      const deltaX = touch.clientX - startCoords.current.x;
      const deltaY = touch.clientY - startCoords.current.y;
  
      // Calculate absolute swipe distance in any direction
      if (Math.abs(deltaX) > threshold || Math.abs(deltaY) > threshold) {
        setShowModal(false);
      }
    };


  return (
    <>
      <button className="open-modal-btn p-1"
        style={{height: "33px"}}
       onClick={() => setShowModal(true)}
       >
        Offers
      </button>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div
            className="modal-container"
            onClick={(e) => e.stopPropagation()}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
          >
            {/* <div className="modal-header">
              <h3>Available Offers</h3>
              <button className="close-btn" onClick={() => setShowModal(false)}>
                ×
              </button>
            </div> */}
            <div className="modal-body">
              {outletData.map((about) =>
                about.offers.map((offer, index) => (
                  <div
                    key={index}
                    className="offer-item"
                    onClick={() => setShowModal(false)}
                  >
                    <span>{offer.offerType}</span>
                    <span>{offer.offerName}</span>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      )}
    </>

  );
}

export default BillTraceModal;
